export default {
  methods: {
    onInputPhone() {
      const newPhone = this.$options.filters.phoneFormat(this.form.phone)
      this.$set(this.form, 'phone', newPhone)
    },
    onInputZipcode() {
      const newZipcode = this.$options.filters.zipFormat(this.form.zipcode)
      this.$set(this.form, 'zipcode', newZipcode)
    },
    // veevalidateのなかによく出てくる一括いい感じバリデーションです
    validateTextFullSize(text, required = false, extra = []) {
      let condition = []
      const regex = /([ァ-ン０-９Ａ-ｚァ-ヶ])/g
      let max = 1000
      if (regex.test(text)) {
        max = 1000
      }
      condition.push(`max:${max}`)
      if (required) condition.push('required')
      if (extra.length) {
        condition = _.concat(condition, extra)
      }
      return condition.join('|')
    },

  }
}
